import { showPupBreedStep } from '../guard';

export const QUIZ_PROGRESS_STEPS = [
  'pupName',
  'pupGender',
  'pupBreed',
  'pupStatus',
  'weight',
  'activity',
  'allergies',
];

export const resolveQuizProgress = flags => {
  const steps = showPupBreedStep({ flags }, { payload: {} })
    ? QUIZ_PROGRESS_STEPS
    : QUIZ_PROGRESS_STEPS.filter(step => step !== 'pupBreed');

  return {
    totalSteps: steps.length,
    getStepNumber: step => {
      const index = steps.indexOf(step);
      return index === -1 ? null : index + 1;
    },
  };
};

export const resolveQuizProgressStep = (flags, step) => {
  const { totalSteps, getStepNumber } = resolveQuizProgress(flags);

  return {
    totalSteps,
    stepNumber: getStepNumber(step),
  };
};
